<template>
  <div id="coupon-usage">
    <el-dialog :title="''" v-model="showModal" custom-class="coupon-usage-modal" @close="close">
      <ul class="coupon-usage-content">
        <li>
          <div class="coupon-qa-title">什么是优惠券</div>
          <div class="coupon-qa-content">上上签定期或不定期进行优惠活动，符合活动规则的用户将获得优惠券。用户获得的优惠券会存放在“我的-优惠券”中，用户可自行查看、使用。</div>
          <div class="coupon-qa-content">优惠券可以在您购买上上签商品或服务时减免相应金额（不可减免快递费、保险费等费用），优惠券不可提现，不可找零，不可转让、赠与。</div>
        </li>
        <li>
          <div class="coupon-qa-title">优惠券使用规则</div>
          <div class="coupon-qa-content">1）单笔订单仅可使用一张优惠券，即优惠券不可叠加使用；您在购买上上签商品或服务时，可自行选择使用哪张优惠券或不使用优惠券。</div>
          <div class="coupon-qa-content">2）优惠券一经使用即失效；如果交易取消或退款的，优惠券将不予退还。</div>
          <div class="coupon-qa-content">3）优惠券到期未使用的，自动失效。</div>
          <div class="coupon-qa-content">4）特价商品属于特惠价格，不支持使用优惠券。</div>
        </li>
      </ul>
      <div class="coupon-usage-bottom">上上签保留对该活动的最终解释权</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'coupon-usage',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.value, // 是否展示
    };
  },
  methods: {
    // 关闭
    close() {
      this.$emit('input', false);
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less">
@import  '../../../../assets/less/variable';
#coupon-usage {
  .coupon-usage-modal {
    width: 620px;
    .el-dialog__body {
      padding: 0 40px 20px 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .coupon-usage-content {
        width: 540px;
        li {
          margin-top: 26px;
          &:first-child {
            margin-top: 0;
          }
          .coupon-qa-title {
            font-size: 14px;
            line-height: 16px;
            color: #333;
            font-weight: bold;
            padding-left: 10px;
            position: relative;
            &::before {
              content: '';
              width: 3px;
              height: 16px;
              background-color: @main;
              position: absolute;
              left: 0;
              top: 0;
              border-radius: 2px;
            }
          }
          .coupon-qa-content {
            font-size: 14px;
            line-height: 24px;
            color: #6f6f6f;
            margin-top: 8px;
            padding-left: 10px;
          }
        }
      }
      .coupon-usage-bottom {
        font-size: 14px;
        color: @text-red;
        margin-top: 36px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/coupon-usage.vue